import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React from 'react';
import PropTypes from 'prop-types';

/**
 * Shows a validation message if one exists.
 */
var FieldValidationMessages = /*#__PURE__*/function (_React$Component) {
  function FieldValidationMessages() {
    _classCallCheck(this, FieldValidationMessages);
    return _callSuper(this, FieldValidationMessages, arguments);
  }
  _inherits(FieldValidationMessages, _React$Component);
  return _createClass(FieldValidationMessages, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      return nextProps.sanitisedError !== this.props.sanitisedError;
    }
  }, {
    key: "render",
    value: function render() {
      var sanitisedError = this.props.sanitisedError;
      return sanitisedError && sanitisedError.message ? /*#__PURE__*/React.createElement("div", {
        className: "field-message error"
      }, sanitisedError.message) : null;
    }
  }]);
}(React.Component);
FieldValidationMessages.propTypes = {
  sanitisedError: PropTypes.object
};
export default FieldValidationMessages;